import { createContext, useState } from "react";
import { Outlet } from "react-router-dom";

const SRMAuthContext = createContext({
  clientAuthInfo: {
    isLoggedIn: false,
    isLoading: true,
    firstName: null,
    lastName: null,
    cellphone: null,
    nationalCode: null,
  },
  setClientAuthInfo: () => {},
});
export default SRMAuthContext;

export const SRMAuthContextProvider = () => {
  const [clientAuthInfo, setClientAuthInfo] = useState({
    isLoggedIn: false,
    isLoading: true,
    firstName: null,
    lastName: null,
    cellphone: null,
    nationalCode: null,
  });

  const context = { clientAuthInfo, setClientAuthInfo };
  return (
    <SRMAuthContext.Provider value={context}>
      <Outlet />
    </SRMAuthContext.Provider>
  );
};
